import { useMemo, useEffect } from "react";
import useMedia from "use-media";
import { Header, MembershipView, RechargeView, UserInfo } from "./components";
import { ChargeType } from "./constants";
import { GlobalDarkStyle, GlobalStyle } from "./constants/global-style";
import { useFetchPicActivity } from "./hook/useFetchPicActivity";
import { ClientTopUpStoreProvider, useClientTopUpStore } from "./store";
import { Billboard, ClientTopUpContainer, ClientTopUpContent } from "./atom";
import { ThemeProvider } from "styled-components";
import { useLocation } from "react-router-dom";
import clientTheme, {
  ThemeType,
} from "project-config/client-theme/client-theme";
import { Toast } from "task-eva-ui";
import { useToastStore } from "@/store/toast-store";

const ClientTopUpView = () => {
  const { activeBar } = useClientTopUpStore();
  const { rechargeActivityList, memberActivityList } = useFetchPicActivity();
  const { themeName, setThemeName } = useClientTopUpStore();
  const isWide = useMedia({ minWidth: "1001px", maxWidth: "1920px" });
  const isLargeWide = useMedia({ minWidth: "1921px" });
  const location = useLocation();
  const themeParam = new URLSearchParams(location.search).get("theme");
  const {
    background,
    bgImage,
    bgWideImage,
    bgLargeWideImage,
    activityBgField,
  } = useMemo(() => {
    return themeName === ThemeType.Dark
      ? GlobalDarkStyle[activeBar]
      : GlobalStyle[activeBar];
  }, [activeBar, themeName]);
  const theme =
    themeParam === ThemeType.Dark
      ? clientTheme[ThemeType.Dark]
      : clientTheme[ThemeType.Light];
  const defaultBg = isLargeWide
    ? bgLargeWideImage
    : isWide
    ? bgWideImage
    : bgImage;
  const memberActivity = memberActivityList?.[0];
  const rechargeActivity = rechargeActivityList?.[0];
  const { toastProps, updateGlobalToast } = useToastStore();

  useEffect(() => {
    setThemeName(
      themeParam === ThemeType.Dark ? ThemeType.Dark : ThemeType.Light
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeParam]);

  const openDetail = (link?: string) => {
    link && link !== "" && window.open(link);
  };

  return (
    <ThemeProvider theme={theme}>
      <ClientTopUpContainer style={{ background }}>
        <ClientTopUpContent isWide={Number(isWide || isLargeWide)}>
          <Header />
          <UserInfo />
          {activeBar === ChargeType.Membership ? (
            <MembershipView memberActivityList={memberActivityList} />
          ) : (
            <RechargeView rechargeActivityList={rechargeActivityList} />
          )}
        </ClientTopUpContent>
        <Billboard>
          <img
            src={
              activeBar === ChargeType.Membership
                ? memberActivity
                  ? memberActivity[activityBgField] || defaultBg
                  : defaultBg
                : rechargeActivity
                ? rechargeActivity[activityBgField] || defaultBg
                : defaultBg
            }
            alt=""
            onClick={() =>
              openDetail(
                activeBar === ChargeType.Membership
                  ? memberActivity?.pictureImageUrlLink
                  : rechargeActivity?.pictureImageUrlLink
              )
            }
            // onClick={() => openDetail('https://www.baidu.com/')}
          />
        </Billboard>
      </ClientTopUpContainer>
      <Toast {...toastProps} setShow={updateGlobalToast} />
    </ThemeProvider>
  );
};
export default function ClientTopUp() {
  return (
    <ClientTopUpStoreProvider>
      <ClientTopUpView />
    </ClientTopUpStoreProvider>
  );
}
